module.exports = __webpack_public_path__ + "static/media/usb-c-silver.ca4fb85c.svg";